import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import { Typography } from '..';
import styles from './BlockHeader.module.scss';

interface OwnProps {}

type BlockHeaderProps = JSX.IntrinsicElements['div'] & OwnProps;

const BlockHeader: FunctionComponent<BlockHeaderProps> = props => {
  const { className, ...rest } = props;

  const blockHeaderClassName = cx({
    [styles.content]: true,
    ...(className && { [className]: true }),
  });

  return <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="h2" className={blockHeaderClassName} {...rest} />;
};

export default BlockHeader;
